export function addBotObjectRule(service) {
  service.addRule('botObject', {
    filter: (node) =>
      node.nodeName === 'SPAN' && node.classList.contains('bot-object'),
    replacement: (content, node) => node.outerHTML,
  })
}
